import React, { FunctionComponent } from 'react';
import Header from '../Header/Header';
import AppWizard from '../AppWizard/AppWizard';
import { AppFooter } from '../Footer/Footer';
import { ContentSection, Main } from '@vwfs-bronson/bronson-react';
import { useLocation } from 'react-router-dom';
import { routes } from '../../routes';
import { useAppSelector } from '../../redux/store';
import { getShouldStepsWizardBeHidden } from '../../redux/slices/appData/app-data.selectors';

const Layout: FunctionComponent<any> = ({ children }) => {
  const { pathname } = useLocation();
  const showWizard = ![
    routes.error as string,
    routes.application.legitimationResult as string,
    routes.sessionTimeout as string
  ].includes(pathname);

  const shouldWizardBeHidden = useAppSelector(getShouldStepsWizardBeHidden);

  return (
    <>
      <Header />
      {showWizard && !shouldWizardBeHidden && <AppWizard />}
      <Main>
        <ContentSection pageWrap>{children}</ContentSection>
      </Main>
      <AppFooter />
    </>
  );
};

export default Layout;
